export var Variable;
(function (Variable) {
  Variable["Width"] = "%WIDTH%";
  Variable["Height"] = "%HEIGHT%";
  Variable["Top"] = "%TOP%";
  Variable["Bottom"] = "%BOTTOM%";
  Variable["Left"] = "%LEFT%";
  Variable["Right"] = "%RIGHT%";
})(Variable || (Variable = {}));